import { ExportColumnGroup } from '../../../../store/mst/models';

export interface ExportColumn {
  key: string;
  label: string;
  group: ExportColumnGroup;
  isCustomField: boolean;
}

export interface ExportColumnGroupData {
  group: ExportColumnGroup;
  columns: ExportColumn[];
}

export const GROUP_ORDER: ExportColumnGroup[] = [
  ExportColumnGroup.ROUTE,
  ExportColumnGroup.ORDER,
  ExportColumnGroup.SCHEDULING,
  ExportColumnGroup.PROOF_OF_DELIVERY,
  ExportColumnGroup.CUSTOM_FIELD,
];

// Columns present in the catalog but left unchecked the first time a user opens the export
// modal (i.e. before they have any saved preference). The backend has no notion of "default
// selected" for a column, so this is a frontend-only opt-out list.
//
// signature: the CSV cell is a signed, expiring link rather than the signature image itself, so
// it's less immediately useful than the other proof-of-delivery columns and shouldn't bloat the
// default export.
export const DEFAULT_UNSELECTED_COLUMN_KEYS: ReadonlySet<string> = new Set(['signature']);
